export default <T = object>(
  records: T[],
  valueKey: string,
  labelKey: string,
) =>
  records.map(record => ({
    value: record[valueKey],
    label: record[labelKey],
  }));
